import { useState } from 'react';
import webApiClient from './../../Utils/webApiClient';
import { msalInstance } from '../../index';
import config from '../../Config/config';
import useRequestHandler from '../useRequestHandler';

/** Hook is used to read contact */
const useReadContact = () => {

    const { errorHandler, successHandler } = useRequestHandler();
    const apiClient = webApiClient();
    const [ contact, setContact ] = useState({});

    /** Read contact by id
     * @param {integer} id - id of the contact entity */
    const readContact = async (contactId) => {
        try {

            // Account is set in the index.js
            const account = msalInstance.getActiveAccount();

            const response = await msalInstance.acquireTokenSilent({
                scopes: config.webApi.scopes,
                account: account
            });
            
            const result = await apiClient.read(response.accessToken, "contacts", contactId);  

            const data = result && result.data ? result.data : null;
            const resultData = data.resultData || null;
            const content = resultData[0] || null;

            if (content) setContact(content);
            if (!content) setContact({});

            return successHandler(result, "useReadContact", "read", { hide: true });

        } catch (error) {
            return errorHandler(error, "useReadContact", "read");
        }
    }

    return { contact, readContact };

}

export default useReadContact;
